import React, { useReducer } from "react";
import axios from "axios";
import EmployeeContext from "./EmployeeContext";
import EmployeeReducer from "./EmployeeReducer";
import {
  EMPLOYEES_LOADING,
  EMPLOYEES_LOADED,
  EMPLOYEES_ERROR,
  EMPLOYEES_RESET,
  SET_CURRENT_EMPLOYEE,
  CLEAR_CURRENT_EMPLOYEE,
  UPDATE_EMPLOYEE,
} from "../types";
import { env } from "../../env";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";
const EmployeeState = (props) => {
  const initialState = {
    error: null,
    employees: null,
    changedEmployees: [],
    employeeLoading: false,
    employeeLoaded: false,
    selectedEmployee: localStorage.getItem("selectedEmployee")
      ? JSON.parse(localStorage.getItem("selectedEmployee"))
      : null,
    savedCriteria: null,
    empCard: null,
  };
  const [state, dispatch] = useReducer(EmployeeReducer, initialState);

  //Reset Context State
  const resetEmployeeState = () => {
    dispatch({
      type: EMPLOYEES_RESET,
      payload: { ...initialState },
    });
  };

  //select a employee for processing
  const setCurrentEmployee = (employee) => {
    dispatch({
      type: SET_CURRENT_EMPLOYEE,
      payload: { employee },
    });
  };
  //Clear employee Selection
  const clearCurrentEmployee = () => {
    dispatch({
      type: CLEAR_CURRENT_EMPLOYEE,
    });
  };

  //Search All employees
  const getEmployees = async (formData, token) => {
    const savedCriteria = { ...formData };
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "EMPLOYEE_MANAGEMENT";
      formData.function = "get_employees";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: EMPLOYEES_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/employee/search`,
          formData,
          config
        );
        console.log("Employees ", res);
        dispatch({
          type: EMPLOYEES_LOADED,
          payload: { employees: res.data, savedCriteria },
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: EMPLOYEES_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Creat a employee
  const createEmployee = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "EMPLOYEE_MANAGEMENT";
      formData.function = "create_employee";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: EMPLOYEES_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/employee/create`,
          formData,
          config
        );
        console.log("Employees ", res);
        dispatch({
          type: UPDATE_EMPLOYEE,
          payload: res.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: EMPLOYEES_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Update Employee Details
  const updateEmployee = (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "EMPLOYEE_MANAGEMENT";
      formData.function = "update_employee";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: EMPLOYEES_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/employee/update`,
          formData,
          config
        );
        console.log("Employees ", res);
        dispatch({
          type: UPDATE_EMPLOYEE,
          payload: res.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: EMPLOYEES_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Update Employee Details
  const removeEmployees = (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "EMPLOYEE_MANAGEMENT";
      formData.function = "remove_employees";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: EMPLOYEES_LOADING,
        });
        let res = await axios.post(
          `${API_HOST}/employee/remove`,
          formData,
          config
        );
        // res = await getEmployees({ filterType: "all", filterValue: "" }, token);
        // console.log("Employees ", res);
        dispatch({
          type: EMPLOYEES_RESET,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: EMPLOYEES_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Get Employee Details
  const loadEmployee = (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "EMPLOYEE_MANAGEMENT";
      formData.function = "employee_detail";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: EMPLOYEES_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/employee/detail`,
          formData,
          config
        );
        console.log("Employees ", res);
        dispatch({
          type: SET_CURRENT_EMPLOYEE,
          payload: res.data.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: EMPLOYEES_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  return (
    <EmployeeContext.Provider
      value={{
        ...state,
        resetEmployeeState,
        setCurrentEmployee,
        clearCurrentEmployee,
        getEmployees,
        createEmployee,
        updateEmployee,
        loadEmployee,
        employeeDispatch: dispatch,
        removeEmployees,
      }}
    >
      {props.children}
    </EmployeeContext.Provider>
  );
};

export default EmployeeState;
